<template>
  <v-dialog v-model="value" persistent max-width="350">
    <v-card>

      <v-card-title>Recover from Handed Over</v-card-title>

      <v-card-text>
        <p>Are you sure you want to recover this account from Handed Over?</p>
        <p>This will move all products in the "Handed Over" status to the "Live" status.</p>
      </v-card-text>

      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" small @click="ok" :loading="getRecoverFromHandedOverLoading" :disabled="getRecoverFromHandedOverLoading">OK</v-btn>
        <v-btn color="primary" small outlined @click="close" :disabled="getRecoverFromHandedOverLoading">Cancel</v-btn>
      </v-card-actions>

    </v-card>
  </v-dialog>
</template>

<script>

  import { mapGetters,mapActions } from 'vuex';

  export default {
    
    props: {
      value: {
        type: Boolean,
        default: false
      },
    },

    computed: {
      ...mapGetters('creditControl',['getCreditControl','getRecoverFromHandedOverLoading','getRecoverFromHandedOverError']),
    },

    methods: {
      ...mapActions('creditControl',['recoverFromHandedOver']),
      ...mapActions('alerts', ['setAlert']),

      async ok(){
        if(this.getCreditControl.status==='Handed Over'){
          await this.recoverFromHandedOver(this.$route.params.id);
          if(!this.getRecoverFromHandedOverError){
            this.close();
          }
        }else{
          this.close();
          this.setAlert({type: 'error', message: `Account is not in Handed Over`});
        }
      },

      close() {
        this.$emit('input',false);
      }

    },

  }
</script>

<style lang="scss" scoped>

</style>
